enum DeliverectOrderType {
  PickUp = '1',
  Delivery = '2',
  EatIn = '3',
  Curbside = '4',
}

export { DeliverectOrderType };
